<template>
  <div>
    <v-dialog v-if="uploadEPLDialog" v-model="uploadEPLDialog" width="700">
      <v-card>
        <v-card-title>
          Import EPL File
        </v-card-title>
        <v-card-text>
          <v-form-file @uploaded="uploadEPL" label="EPL File"
                       target="ofd"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       return-url
                       xx-large></v-form-file>
          <v-form-field
              xx-large
              v-model="blNo"
              label="BL No"></v-form-field>
          <v-form-field
              xx-large
              v-model="hbiNo"
              label="HBI No"></v-form-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['CONTAINER_IMPORT']" @click="importConfirm"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="uploadEPLDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-page-data-table
        title="Shipment Manage"
        key-name="id"
        :fields="fields"
        ref="container"
        @create="onDetail"
        @import="importEPL"
        dense
        :show-edit="false"
        :show-delete="isAdmin"
        :row-actions="rowActions"
        :toolbar-actions="toolActions"
        delete-api="CONTAINER_DELETE"
        query-api="CONTAINER_QUERY">

      <template v-slot:hbiNo="{item}">
        <v-link-text :text="item.hbiNo" @click="onDetail(item)"></v-link-text>
      </template>
      <template v-slot:status="{item}">
        <v-btn text tile small v-if="item.status=='OP'">
          OPEN
        </v-btn>
        <v-btn text tile small v-else-if="item.status=='FN'">
          DONE
        </v-btn>
        <v-btn text tile small v-else-if="item.status=='PK'">
          LOADING
        </v-btn>
      </template>
    </v-page-data-table>
  </div>
</template>

<script>
import ContainerQueryFields from "./fields/ContainerQueryFields";

export default {
  name: "ContainerQuery",
  data() {
    return {
      uploadEPLDialog: false,
      fields: ContainerQueryFields,
      fileUuid: null,
      blNo: null,
      hbiNo: null,
      isAdmin:false,
      rowActions: [],
      toolActions: [
        {
          text: 'upload',
          color: 'primary',
          accessRole:'SMS_ADMIN',
          icon: "mdi-upload",
          action: 'import'
        }
      ]
    }
  },
  created() {
    this.isAdmin=this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    onDetail(item) {
      let id = item ? item.id : undefined;
      this.$router.apmRoute("docDetail", {id: id});
    },
    viewImage(url) {
      window.open(url, '_blank');
    },
    onStartProcess(processType, processTypeName) {
      this.$router.apmRoute("docDetail", {type: processTypeName, source: 'process'});
    },
    importEPL() {
      this.uploadEPLDialog = true;
    },
    uploadEPL(items) {
      if (items && items.length > 0) {
        this.fileUuid = items[0].uuid;
      }
    },
    importConfirm() {
      if (!this.hbiNo) {
        this.$message.error("请输入HBI NO");
        return;
      }
      this.$request.request("CONTAINER_IMPORT", {
        fileUuid: this.fileUuid,
        blNo: this.blNo,
        hbiNo: this.hbiNo
      }).then((response) => {
        this.$message.success("Import success");
        this.uploadEPLDialog = false;
        this.$refs.container.query();
      });
    }
  }
}
</script>
